import { render, staticRenderFns } from "./clients-activity.vue?vue&type=template&id=86b98ac6"
import script from "./clients-activity.vue?vue&type=script&lang=js"
export * from "./clients-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports